import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Line } from 'react-chartjs-2';

function GraficaHumedadPorMaquina({ dataApi, maquina, fechaInicio, fechaFin }) {
  const datosFiltrados = dataApi.filter(d => !maquina || d.maquinaId === maquina);
  const humedadPorDia = {};
  datosFiltrados.forEach(d => {
    if (!humedadPorDia[d.fecha]) humedadPorDia[d.fecha] = [];
    humedadPorDia[d.fecha].push(Number(d.humedadPromedio));
  });
  const labels = Object.keys(humedadPorDia).sort();
  const promedios = labels.map(f => {
    const arr = humedadPorDia[f];
    if (arr.length === 0) return 0;
    return arr.reduce((a, b) => a + b, 0) / arr.length;
  });
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Humedad promedio',
        data: promedios,
        borderColor: 'rgba(55,249,167,1)',
        backgroundColor: 'rgba(55,249,167,0.2)',
        borderWidth: 1, // línea más delgada
        tension: 0.7, // curva más acentuada
        pointRadius: 3,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Humedad por día (${maquina || 'Todas'})` },
    },
    scales: {
      x: {
        title: { display: true, text: 'Día' },
        ticks: {
          font: { size: 10 },
          maxTicksLimit: 28,
          autoSkip: true,
          stepSize: 1,
        },
        grid: {
          lineWidth: 0.5,
          drawTicks: true,
        },
        offset: false,
      },
      y: { title: { display: true, text: 'Humedad (%)' } },
    },
  };
  const filtrosCompletos = maquina && fechaInicio && fechaFin;
  const hayDatos = filtrosCompletos && labels.length > 0 && promedios.some(v => v > 0);
  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Gráfica de humedad por máquina
      </Typography>
      <Box sx={{ height: 350, overflowX: 'auto', width: '100%' }}>
        {!hayDatos ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            No hay datos para el rango seleccionado
          </Typography>
        ) : (
          <Box sx={{ minWidth: 600, maxWidth: '100%' }}>
            <Line data={chartData} options={options} />
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default GraficaHumedadPorMaquina;
